import { Link } from 'react-router-dom';
import { Flag } from 'lucide-react';
import { Button } from '@/components/ui';

interface ClaimBarSectionProps {
  barName: string;
  isClaimed: boolean;
  userManagesBar: boolean;
  isAuthenticated: boolean;
  onClaim: () => void;
  isPending: boolean;
}

export function ClaimBarSection({
  barName,
  isClaimed,
  userManagesBar,
  isAuthenticated,
  onClaim,
  isPending,
}: ClaimBarSectionProps) {
  // Don't show if bar is already claimed or user already manages it
  if (isClaimed || userManagesBar) {
    return null;
  }

  return (
    <div className="mt-8 p-4 border border-[var(--color-border)] rounded-lg bg-[var(--color-card)]">
      <h3 className="font-semibold mb-2">Own or manage {barName}?</h3>
      <p className="text-sm text-[var(--color-muted)] mb-4">
        Claim this listing to update your specials, events, and business info.
        Keep customers informed and attract more visitors.
      </p>
      {isAuthenticated ? (
        <Button
          onClick={onClaim}
          isLoading={isPending}
          className="w-full flex items-center justify-center gap-2"
        >
          <Flag className="h-4 w-4" />
          Claim This Bar
        </Button>
      ) : (
        <Link to="/login">
          <Button variant="secondary" className="w-full">
            Sign in to claim
          </Button>
        </Link>
      )}
    </div>
  );
}
